var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValuation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.666667 68.266667h682.666666a102.4 102.4 0 0 1 102.4 102.4v682.666666a102.4 102.4 0 0 1-102.4 102.4H170.666667a102.4 102.4 0 0 1-102.4-102.4V170.666667a102.4 102.4 0 0 1 102.4-102.4z m0 68.266666a34.133333 34.133333 0 0 0-34.133334 34.133334v682.666666a34.133333 34.133333 0 0 0 34.133334 34.133334h682.666666a34.133333 34.133333 0 0 0 34.133334-34.133334V170.666667a34.133333 34.133333 0 0 0-34.133334-34.133334H170.666667z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.2 477.866667v-68.266667a34.133333 34.133333 0 0 1 68.266667 0v68.266667h68.266666a34.133333 34.133333 0 0 1 0 68.266666h-68.266666v68.266667a34.133333 34.133333 0 0 1-68.266667 0v-68.266667H238.933333a34.133333 34.133333 0 0 1 0-68.266666h68.266667z m273.066667 68.266666a34.133333 34.133333 0 0 1 0-68.266666h204.8a34.133333 34.133333 0 0 1 0 68.266666h-204.8z",
    fill: "#FF7214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuation);
export default __webpack_public_path__ + "static/media/valuation.4a53cceab126c05a166a6d94ab79e73a.svg";
export { ForwardRef as ReactComponent };